module.exports = __webpack_public_path__ + "img/icon_home1.5eb73990.3d89b3c6.svg";